// src/router.js
import { createRouter, createWebHistory } from 'vue-router'
import ReaderPage from '@/pages/ReaderPage.vue'
import { pageView } from '@/utils/analytics'
import { frontDoorSub } from '@/utils/mystic-host'

const MysticFrontDoor = () => import('@/pages/MysticFrontDoor.vue')

// A Mystic's front door (mystic-page 2026-10-29, OUTLINE decision 2): on
// `{sub}.mysticaida.ai` the bare address is the Mystic's public page. The
// app's own hosts, and any app URL on that host, are the app.
export function homeEnter (to, hostname = (typeof window !== 'undefined' ? window.location.hostname : '')) {
  const search = to.fullPath && to.fullPath.includes('?') ? to.fullPath.slice(to.fullPath.indexOf('?')) : ''
  const sub = frontDoorSub({ hostname, pathname: to.path, search })
  return sub ? { path: `/m/${sub}`, query: to.query, replace: true } : true
}

const routes = [
  { path: '/', component: ReaderPage, beforeEnter: (to) => homeEnter(to) },
  // The Mystic's public page, signed out (also what {sub}.mysticaida.ai shows).
  {
    path: '/m/:sub',
    component: MysticFrontDoor,
    props: route => ({ sub: String(route.params.sub || '').toLowerCase(), via: route.query.via === 'qr' ? 'qr' : 'link' }),
  },
  // The old Create-a-Mystic flow (/onboarding, kindle.mysticaida.ai), its
  // /studio dashboard and /marketplace are gone (BUILD-DECISIONS 13,
  // 2026-10-26). An old link never dead-ends: the Studio is the in-app panel
  // (which the server gates), the rest go home.
  { path: '/studio', redirect: { path: '/', query: { panel: 'studio' } } },
  { path: '/onboarding', redirect: '/' },
  { path: '/kindle', redirect: '/' },
  { path: '/marketplace', redirect: '/' },
  {
    path: '/reader/:subdomain',
    component: ReaderPage,
    props: route => ({ readerSubdomain: route.params.subdomain }),
  },
  {
    path: '/seeker/:nickName',
    component: ReaderPage,
    props: route => ({ seekerNickName: route.params.nickName }),
  },
  {
    path: '/seeker/:nickName/reading/:readingId',
    component: ReaderPage,
    props: route => ({ seekerNickName: route.params.nickName, seekerReadingId: route.params.readingId }),
  },
  {
    path: '/reset-password',
    component: () => import('@/components/ui/ResetPassword.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Every surface change is a page view under a virtual path (/altar/journal,
// /community/fireside, /reader/<sub>…); the app is otherwise all "/".
// Panel and tab switches reach here too: they sync the URL with router.replace.
router.afterEach((to, from, failure) => {
  if (!failure) pageView(to)
})

export default router
